import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import { RButton } from "../ratifikaElements";
import exportIllustration from "../../imgs/export.png";

interface Props {
  open: boolean;
  title?: string;
  body?: string;
  acceptBtnText?: string;
  handleClose: () => void;
}

export const ExportDialog: React.FC<Props> = ({
  open,
  title,
  body,
  acceptBtnText,
  handleClose,
}) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      {title && <DialogTitle id="alert-dialog-title">{title}</DialogTitle>}
      {body && (
        <DialogContent style={{ minWidth: 500 }}>
          <div style={{ textAlign: "center", padding: 10 }}>
            <img style={{ width: 180 }} src={exportIllustration} alt="Exportar" />
          </div>
          <DialogContentText id="alert-dialog-description">{body}</DialogContentText>
        </DialogContent>
      )}
      <DialogActions style={{ padding: 20 }}>
        <RButton onClick={handleClose} color="primary" variant="contained" autoFocus>
          {acceptBtnText || "Aceptar"}
        </RButton>
      </DialogActions>
    </Dialog>
  );
};
